import { Phone } from "lucide-react";

const StickyCallButton = () => {
  return (
    <>
      {/* Mobile sticky call button */}
      <a
        href="tel:07968790128"
        className="fixed bottom-4 right-4 z-50 bg-[#1A4D2E] text-white rounded-full p-4 shadow-lg md:hidden flex items-center gap-2 hover:bg-[#143D24] transition-colors"
        aria-label="Call us"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-5 h-5" />
        <span className="font-semibold text-sm">Call Now</span>
      </a>
    </>
  );
};

export default StickyCallButton;
